import React, {useState} from 'react';
import {Icon, Modal, Table} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import moment from 'moment';
import {reverseShortDate} from '../../../common/constants/datesFormat';

const SummaryByRequestModal = ({
  accessoryRequestedTotal,
  accessoryRequestsList,
}) => {
  const [detailCardVisible, setDetailCardVisible] = useState(false);

  const handleModal = (e, value) => {
    e.preventDefault();
    setDetailCardVisible(value);
  };

  return (
    <Modal size='small'
      trigger={<Link to='' onClick={(e) => handleModal(e, true)}>{accessoryRequestedTotal}</Link>}
      header={
        <div className='header flex'>
          <h2 className='flex grow' style={{'margin': 0}}>Detalle de pedidos despachados</h2>
          <Icon className='download' name='close' style={{'margin': 0, 'cursor': 'pointer'}}
            onClick={(e) => handleModal(e, false)} />
        </div>
      }
      open={detailCardVisible}
      content={
        <div className="m-2">
          <Table striped className='dashboard-table'>
            <Table.Header className='orders-table-header'>
              <Table.Row>
                <Table.HeaderCell>Pedido</Table.HeaderCell>
                <Table.HeaderCell>Fecha</Table.HeaderCell>
                <Table.HeaderCell>Cantidad</Table.HeaderCell>
                <Table.HeaderCell>Fecha Entrega</Table.HeaderCell>
                <Table.HeaderCell>Despachado por</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {
                accessoryRequestsList.map((detail, index) => {
                  return <Table.Row key={index}>
                    <Table.Cell>{detail.request}</Table.Cell>
                    <Table.Cell>{moment(detail.requestDate).format(reverseShortDate)}</Table.Cell>
                    <Table.Cell>{detail.delivered}</Table.Cell>
                    <Table.Cell>{moment(detail.deliveryDate).format(reverseShortDate)}</Table.Cell>
                    <Table.Cell>{detail.deliveryUser}</Table.Cell>
                  </Table.Row>;
                })
              }
            </Table.Body>
          </Table>
        </div>
      }
    />
  );
};

export default SummaryByRequestModal;
